import styled, {keyframes} from 'styled-components'

const blink = keyframes`
    0% {left: 0; top: 0;width: 50px;}
    25% {left: 100%; top: 0; width: 3px;}
    50% {left: 100%; top: 100%;width: 50px;}
    75% {left: 0; top: 100%;width: 3px;}
    100% {left: 0; top: 0; width: 3px;} 
`

const blinkNew = keyframes`
    0% {left: 0; top: 0;width: 50px;}
    25% {left: calc(100% - 3px); top: 0; width: 3px;}
    50% {left: 100%; top: 100%;width: 50px;}
    75% {left: 0; top: 100%;width: 3px;}
    100% {left: 0; top: 0; width: 3px;} 
`
const blinkSla = keyframes`
    0% {left: 0; top: 0;width: 50px;}
    25% {left: 100%; top: 0; width: 3px;}
    50% {left: 100%; top: 100%;width: 50px;}
    75% {left: 0; top: 100%;width: 3px;}
    100% {left: 0; top: 0; width: 3px;} 
`

const Container = styled.ul`
    a {
        text-decoration: none;
        color: inherit;
    }
    >.active:before{
        content: "\00a0";
        border-left: .2rem solid #4DD0E1;
        left: 0;
        top: 0;
        position: absolute;
        height: 100%;
    }
    &.status{
        background-color: #FFF;
        padding: 0 .1rem;
        li{
            background-color: #FFF;
            &+ li{
                margin-top: .95rem;
            }
            color:#4DBCAC;
            &:hover{
                background-color: rgba(122,204,211,0.08);
                color:#4DBCAC;
            }
            &.blink:not(.active) {
                &:before {
                    content: '';
                    display: block;
                    width: 10%;
                    background-color: #4DBCAC;
                    position: absolute;
                    top: 0;
                    height: 2px;
                }
                &:before {
                    animation: ${blink} 2.5s linear infinite;
                }
                &.new:not(.active) {
                    &:before {
                        animation: ${blinkNew} 2.5s linear infinite;
                    }
                }
            }
            
            &.closed{
                &:hover {
                    background-color: rgba(236,62,162,0.08);
                }
                color:#EC3EA2;
                &.active{
                    background-color:#EC3EA2;
                }
            }
            &.category{
                &:hover {
                    background-color: rgba(172, 92, 202,0.08);
                }
                color:#AC5CCA;
                &.active{
                    background-color:#AC5CCA;
                }
                &.blinkSLA:not(.active) {
                    &:before {
                    content: '';
                    display: block;
                    width: 10%;
                    background-color: rgb(202,42,58);
                    position: absolute;
                    top: 0;
                    height: 2px;
                     animation: ${blinkSla} 2.5s linear infinite;
                    }
                }
                
            }
            p {
                margin-left: auto;
                color: inherit;
                font-weight: bold;
                width: 25px;
                text-align: center;
            }
            &.active{
                background-color: #4DBCAC;
                
                color: #FFF;
                font-weight: bold;
                &:before{
                    content: none;
                }
            }
        }
    }
    .active{
        color: #4DD0E1;
    }
    
    ${props => props.centerChildren && ` 
        > li {
            display: flex;
            align-items:center;
            justify-content:center;
            margin: 0 auto;
            width: 100%;
            height: fit-content;
        }
        li > div {
           padding: 0;
        }
        
        span.badge{
            color: #fafafa;
            background-color: #212121;
        }
        span.badge.hidden{
            display: none;
        }
        li.active {
            color: #ac5cca;
        }
       
        li.active span.badge{
            color: #fafafa;
            background-color: #ac5cca;
        }
        > li.active:before{
           border-left: none;
        }
        `}
        ${props => props.centerChildren && !props.noColor && `
         li svg{
            stroke:  #000;
            fill:  #000;
        }
        li.active svg{
            stroke:  #ac5cca;
            fill:  #ac5cca;
        }
        `}
        ${props => props.centerChildren && props.activeColor && `
        li.active svg {
            stroke:  ${props.activeColor};
        }
        li.active span.badge{
            background-color: ${props.activeColor};
        }
        `}
    .link:not(.icon) {
        padding: 0;
        /*box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);*/
        border-radius: 5px;
        > a {
            padding: 9px 20px;
            width: 100%;
            height: 100%;
        }
    }
    ${props => props.iconSize && `li svg {height: ${props.iconSize};width: ${props.iconSize};}`}         
    ${props => props.menuActive && `li.active {background-color: rgba(21,169,173,.2);} li svg {fill: #999999; stroke: #999999;} li.active {color: ${props.menuActive};} li.active svg {fill: ${props.menuActive}; stroke: ${props.menuActive};}`}         
    ${props => props.iconMargin && ` > li > svg {margin: ${props.iconMargin};}`}         
    ${props => props.margin ? `margin: ${props.margin};` : `margin: 0 auto;`}
    ${props => props.height && `height: ${props.height};`}
    ${props => props.width && `width: ${props.width};`}
    ${props => props.fontSize && `li span{font-size: ${props.fontSize};}`}
    ${props => props.paddingChildren && `li > a {padding: ${props.paddingChildren};} li {padding: 0; width: fit-content;} li.badge>a {padding-right: calc(${props.paddingChildren} + .5rem);}`}
    ${props => props.column && `> li {flex-flow: column;}`}
    ${props => props.badgeColor && `> li span.badge {background-color: ${props.badgeColor};}`}
    color: ${props => props.color ? `${props.color}` : `inherit`};
    > a, li span,li svg {color: inherit;font-weight: inherit}
    li.menu_flow > a{ padding: 1.25rem .85rem;} 
    li.menu_flow{display: flex; justify-content: center; width: 100%;}
    li.menu_flow svg{ width: 3rem; }
   `

export default Container